import React from 'react';

export default function MapImageNotice({status, hasSite, onCapture}){
	let isStarted = status === "open" || status === "closed";

	if (!hasSite){
		return <div className="alert alert-warning position-static" role="alert">
			<em>Select a site to capture a map image. A map image is required to close out the inspection.</em>
		</div>
	}

	return <div className={"alert position-static alert-warning" } role="alert">
		<em>
			A map image is required to close out this inspection and appears in the PDF report.
			{isStarted ? "" : " You can capture it now or later."}
		</em>
		<p className="mb-0">
			<button type="button" className={"btn btn-round btn-small mt-3 btn-warning"} onClick={onCapture}>
				<i className="fa fa-camera mr-2 mt-n5"></i>
				Capture Map Picture
			</button>
		</p>
	</div>
}
